<template>
    <div class="profile-active" v-if="showProfileActive">
        <router-link to="/profile" class="profile__link">
            <img :src="env.public_base + '/assets/images/person-icon.svg'" alt="">
            <span>{{ $t("profile") }}</span>
        </router-link>

        <a href="" class="profile__link" @click="logout">
            <img :src="env.public_base + '/assets/images/logout-icon.svg'" alt="">
            <span>{{ $t("logout") }}</span>
        </a>

        <button type="button" class="button button--profile-close" @click="hideProfileActive">
            <img :src="env.public_base + '/assets/images/cross-icon.svg'" alt="">
        </button>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from '../env';
    export default {
        computed: {
            ...mapGetters([
                'showProfileActive'
            ]),
        },
        methods: {
            logout(){
                this.$store.dispatch('logout');
                this.$router.push({ name: 'login' });
            },
            hideProfileActive(){
                this.$store.dispatch('showProfileActive', false);
            }
        },
        data: function () {
            return {
                env
            }
        },

    }
</script>
